import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { ButtonModule } from '../button';
import { DropdownComponent } from './dropdown.component';
import { DropdownItemComponent } from './dropdown-item.component';
import { DropdownToggleComponent } from './dropdown-toggle.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    NgbDropdownModule
  ],
  declarations: [
    DropdownComponent,
    DropdownItemComponent,
    DropdownToggleComponent
  ],
  exports: [
    DropdownComponent,
    DropdownItemComponent,
    DropdownToggleComponent
  ]
})
export class DropdownModule { }
